import React from 'react';

interface Team {
  id: string;
  name?: string;
}

interface ResourceOpenSlots {
  claimOwner: number;
  virtual: number;
  field: number;
}

interface AdditionalResources {
  fieldByDate: number;
  claimOwnerByDate: number;
  virtualByDate: number;
}

interface Item {
  id?: string;
  team: Team;
  teamName: string;
  externalResourceId: string;
  resourceOpenSlots: ResourceOpenSlots;
  additionalResources: AdditionalResources;
  openSlotsClaimOwnerResource?: number;
  openSlotsVirtualResource?: number;
  openSlotsFieldResource?: number;
  additionalResourcesFieldByDate?: number;
  additionalResourcesClaimOwnerByDate?: number;
  additionalResourcesVirtualByDate?: number;
  totalFieldData?: number;
  totalVirtualData?: number;
  totalClaimOwnerData?: number;
  totalClaimOwnerOpenSlots?: number;
  totalVirtualOpenSlots?: number;
  totalFieldOpenSlots?: number;
}

interface Totals {
  field: {
    additionalResourceCount: number;
    activeResourcesCount: number;
    openSlotsCount: number;
  };
  virtual: {
    additionalResourceCount: number;
    activeResourcesCount: number;
    openSlotsCount: number;
  };
  claimOwner: {
    additionalResourceCount: number;
    activeResourcesCount: number;
    openSlotsCount: number;
  };
}

interface Data {
  capacityType?: string;
  totals: Totals;
  data: Item[];
}

export const useFormatData = (
  data?: Data,
  companyTeamsLookup?: Record<string, string>
) => {
  const { capacityType, totals, data: rawRowData } = data || {};

  const rows = React.useMemo(() => {
    return rawRowData?.map?.((item: Item) => {
      const { resourceOpenSlots, additionalResources } = item;

      const resourceTeamId = item.team?.id;
      const teamName = companyTeamsLookup?.[resourceTeamId];
      item.team.name = teamName;
      item.teamName = `${teamName}` || '';

      item.openSlotsClaimOwnerResource = resourceOpenSlots?.claimOwner;
      item.openSlotsVirtualResource = resourceOpenSlots?.virtual;
      item.openSlotsFieldResource = resourceOpenSlots?.field;

      item.additionalResourcesFieldByDate = additionalResources?.fieldByDate;
      item.additionalResourcesClaimOwnerByDate =
        additionalResources?.claimOwnerByDate;
      item.additionalResourcesVirtualByDate =
        additionalResources?.virtualByDate;

      item.totalFieldOpenSlots = totals?.field.openSlotsCount;
      item.totalVirtualOpenSlots = totals?.virtual.openSlotsCount;
      item.totalClaimOwnerOpenSlots = totals?.claimOwner.openSlotsCount;

      item.totalFieldData = totals?.field.additionalResourceCount;
      item.totalVirtualData = totals?.virtual.additionalResourceCount;
      item.totalClaimOwnerData = totals?.claimOwner.additionalResourceCount;

      return item;
    });
  }, [capacityType, data, companyTeamsLookup]);

  return rows;
};
